import { Injectable } from '@angular/core';
import { RoadbookDownloadInfo } from '../models/roadbookDownloadInfo.model';
import * as firebase from 'firebase';
import { AngularFirestore } from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  database = 'Release';
  databaseTrash = 'ReleaseTrash';
  constructor() {
  }

  get ref() {
    return firebase.firestore().collection(this.database);
  }
  getData() {
      return firebase.firestore().doc(`${this.database}/InfoApp`).get().then((data) => {
        return data.data();
      });
  }
  update(radius: number) {
        return firebase.firestore().doc(`${this.database}/InfoApp`).set({radiusKM: radius}, {merge: true});
  }
}
